module.exports = __webpack_public_path__ + "img/item1.c8694b2e.png";